export const SET_CURRENT_REG_HOLDER = 'SET_CURRENT_REG_HOLDER'


// WEBPACK FOOTER //
// ./src/layout/authorised-layout/current-reg-holder/constants.js